import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import * as fromAccountStore from "src/app/store/reducers/account.reducer";
import { TranslateService } from "@ngx-translate/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Exercise } from "src/app/shared/interfaces/exercise";

@Component({
  selector: "exercise-solve-confirm-modal",
  templateUrl: "./exercise-solve-confirm-modal.component.html",
  styleUrls: ["./exercise-solve-confirm-modal.component.scss"],
})
export class ExerciseSolveConfirmModalComponent implements OnInit, OnDestroy {
  isTeacher$: Observable<boolean> = this.store.select(
    (state) => state.account.member.is_teacher,
  );

  langChange: Subscription;
  currentLang: string;

  constructor(
    private store: Store<{ account: fromAccountStore.AccountState }>,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<ExerciseSolveConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { exercise: Exercise },
  ) {}

  ngOnInit() {
    this.currentLang = this.translate.currentLang;

    this.langChange = this.translate.onLangChange.subscribe(() => {
      this.currentLang = this.translate.currentLang;
    });
  }

  ngOnDestroy() {
    this.langChange.unsubscribe();
  }

  closeConfirm() {
    this.dialogRef.close("confirm");
  }
}
